import React from 'react'
import styles from '../KYCDetailsStyles/KYCDetailsStyle.module.scss'
import {BusinessTypeDataType, KYCDetailsBasicFormDataType} from '../KYCDetailsDataType'
import MuiPhoneNumber from 'material-ui-phone-number'

const KYCDetailsBasicForm = ({
  formik,
  businessType,
  country,
  handleChangeCountry,
  province,
}: KYCDetailsBasicFormDataType) => {
  return (
    <>
      {/* Begin: section basic details */}
      {/* Begin: heading basic details */}
      <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>Basic Details</h2>
      {/* End: heading basic details */}
      <div className='d-flex justify-content-between w-100 flex-wrap'>
        {/*Begin::Form Group KYC Unique ID */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>KYC Unique ID</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify KYC unique ID. Only alphanumeric characters, _ and - are allowed'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='e.g. Vitta123, Example-123'
            {...formik.getFieldProps('account_kyc_name')}
            name='account_kyc_name'
          />
          <div className='h-20px'>
            {formik.touched.account_kyc_name && formik.errors.account_kyc_name && (
              <div className='fv-help-block color-red'>{formik.errors.account_kyc_name}</div>
            )}
          </div>
        </div>
        {/*End::Form Group KYC Unique ID */}
        {/*Begin::Form Group Business Name */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Business Name</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify business name'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter business name'
            {...formik.getFieldProps('business_name')}
            name='business_name'
          />
          <div className='h-20px'>
            {formik.touched.business_name && formik.errors.business_name && (
              <div className='fv-help-block color-red'>{formik.errors.business_name}</div>
            )}
          </div>
        </div>
        {/*End::Form Group Business Name */}
        {/*Begin::Form Group Business Type */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Business Type</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose business type'
            ></i>
          </label>
          <select
            className='form-select form-select-solid'
            placeholder='Choose business type'
            {...formik.getFieldProps('business_registartion_type_uuid')}
            name='business_registartion_type_uuid'
          >
            <option className='bg-color-gray' value=''>
              Choose business type
            </option>
            {businessType?.map((item: BusinessTypeDataType) => {
              return (
                <option
                  key={item.business_registartion_type_uuid}
                  value={item.business_registartion_type_uuid}
                >
                  {item.business_registartion_type_name}
                </option>
              )
            })}
          </select>
          <div className='h-20px'>
            {formik.touched.business_registartion_type_uuid &&
              formik.errors.business_registartion_type_uuid && (
                <div className='fv-help-block color-red'>
                  {formik.errors.business_registartion_type_uuid}
                </div>
              )}
          </div>
        </div>
        {/*End::Form Group Business Type */}
      </div>
      {/* End: section basic details */}

      <hr className='py-2 text-primary' />
      
      {/* Begin: section Bank Account Details */}
      {/* Begin: heading Bank Account Details */}
      <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>
        Bank Account Details
      </h2>
      {/* End: heading Bank Account Details */}
      <div className='d-flex justify-content-between w-100 flex-wrap'>
        {/*Begin::Form Group Bank Account Holder Name */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Account Holder Name</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify bank account holder name'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter account holder name'
            {...formik.getFieldProps('account_holder_name')}
            name='account_holder_name'
          />
          <div className='h-20px'>
            {formik.touched.account_holder_name && formik.errors.account_holder_name && (
              <div className='fv-help-block color-red'>{formik.errors.account_holder_name}</div>
            )}
          </div>
        </div>
        {/*End::Form Group Bank Account Holder Name */}
        {/*Begin::Form Group IFSC Number */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>IFSC Code</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify IFSC code'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter IFSC code'
            {...formik.getFieldProps('ifsc_swift_code')}
            name='ifsc_swift_code'
          />
          <div className='h-20px'>
            {formik.touched.ifsc_swift_code && formik.errors.ifsc_swift_code && (
              <div className='fv-help-block color-red'>{formik.errors.ifsc_swift_code}</div>
            )}
          </div>
        </div>
        {/*End::Form Group IFSC Number */}
        {/*Begin::Form Group Bank Account Number */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Bank Account Number</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify bank account number'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter bank account number'
            {...formik.getFieldProps('account_no')}
            name='account_no'
          />
          <div className='h-20px'>
            {formik.touched.account_no && formik.errors.account_no && (
              <div className='fv-help-block color-red'>{formik.errors.account_no}</div>
            )}
          </div>
        </div>
        {/*End::Form Group Bank Account Number */}
        {/*Begin::Form Group Confirm Bank Account Number */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Confirm Bank Account Number</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify bank account number'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Confirm bank account number'
            {...formik.getFieldProps('confirm_account_no')}
            name='confirm_account_no'
          />
          <div className='h-20px'>
            {formik.touched.confirm_account_no && formik.errors.confirm_account_no && (
              <div className='fv-help-block color-red'>{formik.errors.confirm_account_no}</div>
            )}
          </div>
        </div>
        {/*End::Form Group Confirm Bank Account Number */}
        {/*Begin::Form Group Bank Registered Email ID */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Bank Registered Email ID</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify bank account registered email ID'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter bank account registered email ID'
            {...formik.getFieldProps('account_email_id')}
            name='account_email_id'
          />
          <div className='h-20px'>
            {formik.touched.account_email_id && formik.errors.account_email_id && (
              <div className='fv-help-block color-red'>{formik.errors.account_email_id}</div>
            )}
          </div>
        </div>
        {/*End::Form Group Bank Registered Email ID */}
        {/*Begin::Form Group Bank Registered Phone Number */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Bank Registered Phone Number</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Specify bank account registered phone number'
            ></i>
          </label>
          <MuiPhoneNumber
            {...formik.getFieldProps('account_phone_number')}
            className='w-100'
            defaultCountry={'in'}
            onChange={(value) => formik.setFieldValue('account_phone_number', value)}
          />
          <div className='h-20px'>
            {formik.touched.account_phone_number && formik.errors.account_phone_number && (
              <div className='fv-help-block color-red'>{formik.errors.account_phone_number}</div>
            )}
          </div>
        </div>
        {/*End::Form Group Bank Registered Phone Number */}
      </div>
      {/* End: section Bank Account Details */}

      <hr className='py-2 text-primary' />
      
      <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4'>Billing Address</h2>
      <div className='d-flex justify-content-between w-100 flex-wrap'>
        {/*Begin::Form Group Address Line 1 */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Address Line 1</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter complete address'
            ></i>
          </label>
          <textarea
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter address'
            {...formik.getFieldProps('address_1')}
            name='address_1'
          />
          <div className='h-20px'>
            {formik.touched.address_1 && formik.errors.address_1 && (
              <div className='fv-help-block color-red'>{formik.errors.address_1}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Address Line 1 */}
        {/*Begin::Form Group Address Line 2*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Address Line 2</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter complete address'
            ></i>
          </label>
          <textarea
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter address'
            {...formik.getFieldProps('address_2')}
            name='address_2'
          />
          <div className='h-20px'>
            {formik.touched.address_2 && formik.errors.address_2 && (
              <div className='fv-help-block color-red'>{formik.errors.address_2}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Address Line 2*/}
        {/*Begin::Form Group Country*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Country</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose your country'
            ></i>
          </label>
          <select
            className='form-select form-select-solid'
            placeholder='Select country'
            {...formik.getFieldProps('country_id')}
            name='country_id'
            onChange={(e) => handleChangeCountry(e.target.value)}
          >
            <option className='bg-color-gray' value=''>
              Select country
            </option>
            {country?.map((item) => {
              return (
                <option key={item.country_id} value={item.country_id}>
                  {item.country_name}
                </option>
              )
            })}
          </select>
          <div className='h-20px'>
            {formik.touched.country_id && formik.errors.country_id && (
              <div className='fv-help-block color-red'>{formik.errors.country_id}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Country*/}
        {/*Begin::Form Group Province/State*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>Province/State</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose your province/state'
            ></i>
          </label>
          <select
            className='form-select form-select-solid'
            placeholder='Select province/state'
            {...formik.getFieldProps('province_id')}
            name='province_id'
          >
            <option className='bg-color-gray' value=''>
              Select province/state
            </option>
            {province.map((item) => {
              return (
                <option key={item.province_id} value={item.province_id}>
                  {item.province_name}
                </option>
              )
            })}
          </select>
          <div className='h-20px'>
            {formik.touched.province_id && formik.errors.province_id && (
              <div className='fv-help-block color-red'>{formik.errors.province_id}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Province/State*/}
        {/*Begin::Form Group city*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>City</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter city name'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter city'
            {...formik.getFieldProps('city')}
            name='city'
          />
          <div className='h-20px'>
            {formik.touched.city && formik.errors.city && (
              <div className='fv-help-block color-red'>{formik.errors.city}</div>
            )}
          </div>
        </div>
        {/*end::Form Group city*/}
        {/*Begin::Form Group PIN/Postcode*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span>PIN/Postcode</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter pincode'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter PIN/Postcode'
            {...formik.getFieldProps('pin_zip')}
            name='pin_zip'
          />
          <div className='h-20px'>
            {formik.touched.pin_zip && formik.errors.pin_zip && (
              <div className='fv-help-block color-red'>{formik.errors.pin_zip}</div>
            )}
          </div>
        </div>
        {/*end::Form Group PIN/Postcode*/}
      </div>
    </>
  )
}

export default KYCDetailsBasicForm
